import { render } from "./ProtocolMatrix.vue?vue&type=template&id=5971db8e&scoped=true"
import script from "./ProtocolMatrix.vue?vue&type=script&lang=js"
export * from "./ProtocolMatrix.vue?vue&type=script&lang=js"

import "./ProtocolMatrix.vue?vue&type=style&index=0&id=5971db8e&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5971db8e"]])

export default __exports__